import { render, staticRenderFns } from "./mult-uploader.vue?vue&type=template&id=20cf2772&scoped=true&"
import script from "./mult-uploader.vue?vue&type=script&lang=js&"
export * from "./mult-uploader.vue?vue&type=script&lang=js&"
import style0 from "./mult-uploader.vue?vue&type=style&index=0&id=20cf2772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf2772",
  null
  
)

export default component.exports